import { quickFeed } from "@/mocks/homeData";

const RAIL = [
  { label: "人物塌房档案", icon: "ri-user-unfollow-line", meta: "46 篇" },
  { label: "综艺名场面", icon: "ri-clapperboard-line", meta: "38 篇" },
  { label: "社媒翻车合集", icon: "ri-close-circle-line", meta: "27 篇" },
  { label: "真相复盘会", icon: "ri-eye-2-line", meta: "19 篇" },
  { label: "年度盘点大会", icon: "ri-award-line", meta: "52 篇" },
];

export default function FlashFeed() {
  return (
    <section id="kuaiti" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-8 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="flex h-2.5 w-2.5 items-center justify-center">
              <span className="h-2.5 w-2.5 rounded-full bg-primary-500 animate-softpulse" />
            </span>
            <span className="text-xs font-black tracking-[0.25em] text-primary-600 uppercase">LIVE</span>
          </div>
          <span className="text-xs text-foreground-500">更新于 09:42</span>
        </div>

        <div className="grid gap-8 lg:grid-cols-[1fr_340px] lg:gap-10">
          {/* 时间线快讯流 */}
          <div className="relative pl-4 md:pl-6">
            <span className="absolute left-0 top-2 h-full w-px bg-background-300 md:left-2" />
            <ul className="flex flex-col gap-7">
              {quickFeed.map((item, idx) => (
                <li key={item.title} className="relative">
                  <span className="absolute -left-4 top-2 h-3 w-3 rounded-full border-2 border-primary-500 bg-background-50 md:-left-2" />
                  <div
                    className={`grid gap-5 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:bg-background-100 md:p-5 ${
                      idx === 0 ? "md:grid-cols-[240px_1fr] md:items-start" : ""
                    }`}
                  >
                    {idx === 0 && item.image && (
                      <a href="#" className="block overflow-hidden rounded-md">
                        <img
                          src={item.image}
                          alt={item.title}
                          title={`${item.title} - 嘿料吃瓜档案`}
                          className="h-40 w-full object-cover object-top md:h-32"
                        />
                      </a>
                    )}
                    <div className="flex flex-col gap-2">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded bg-primary-100 px-2 py-0.5 text-xs font-bold text-primary-700">{item.tag}</span>
                        <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                          {item.date} · {item.time}
                        </span>
                        {item.hot && (
                          <span className="flex items-center gap-1 text-[11px] font-medium text-accent-700">
                            <span className="flex h-3.5 w-3.5 items-center justify-center">
                              <i className="ri-fire-fill text-xs" />
                            </span>
                            {item.hot}
                          </span>
                        )}
                      </div>
                      <a href="#" className="font-heading text-base font-bold leading-snug text-foreground-950 hover:text-primary-600 md:text-lg">
                        {item.title}
                      </a>
                      <p className="text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
                      <a href="#" className="mt-1 inline-flex items-center gap-1 whitespace-nowrap text-xs font-bold text-primary-600 hover:text-primary-700">
                        展开时间线
                        <span className="flex h-4 w-4 items-center justify-center">
                          <i className="ri-arrow-right-s-line" />
                        </span>
                      </a>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <div className="mt-7 flex justify-center">
              <a
                href="#"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-bold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                加载更多快讯
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-loader-4-line" />
                </span>
              </a>
            </div>
          </div>

          {/* 栏目速览 rail */}
          <aside className="hidden lg:block">
            <div className="sticky top-24 rounded-lg border border-background-200 bg-background-100 p-5">
              <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">档案速览</span>
              <ul className="mt-4 flex flex-col gap-1">
                {RAIL.map((r) => (
                  <a
                    key={r.label}
                    href="#heji"
                    className="group flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-50"
                  >
                    <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-50 text-primary-600">
                      <i className={`${r.icon} text-base`} />
                    </span>
                    <span className="flex-1 text-sm font-medium text-foreground-800 group-hover:text-primary-600">{r.label}</span>
                    <span className="text-xs text-foreground-400">{r.meta}</span>
                  </a>
                ))}
              </ul>
              <div className="mt-4 rounded-md border border-primary-200 bg-primary-100/60 p-3">
                <p className="text-xs leading-relaxed text-foreground-600">
                  吃瓜提醒：本栏目仅作信息归档与内容复盘，不站队、不网暴，理性吃瓜。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}